module.exports = __webpack_public_path__ + "static/media/DK.cf9667dc.png";